<template>
  <div
    class="ra-avatar"
    :style="{
      height: `${size}px`,
      width: `${size}px`,
      backgroundColor: fallbackBackground,
      borderRadius: borderRadius
    }"
  >
    <img
      :src="src || fallbackIcon"
      alt="User"
      :class="{ 'user-icon': !src }"
      :style="{ height: src ? '100%' : `${size / 2.5}px` }"
    />
  </div>
</template>

<script>
export default {
  name: "RaAvatar",
  props: {
    src: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 50
    },
    shape: {
      type: String,
      default: "circle"
    },
    background: {
      type: String,
      default: ""
    },
    iconType: {
      type: String,
      default: "user"
    }
  },

  data() {
    return {};
  },
  computed: {
    borderRadius() {
      return this.shape === "rounded" ? "8px" : "100px";
    },
    fallbackIcon() {
      return require(`@/assets/img/empty/${
        this.iconType === "user" ? "user" : "app"
      }.svg`);
    },
    fallbackBackground() {
      return this.background
        ? this.background
        : this.iconType === "user"
        ? "#798B8330"
        : "#9e1531";
    }
  }
};
</script>

<style scoped lang="scss">
.ra-avatar {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 2px #57645e29;

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    border-radius: 100%;

    &.user-icon {
      object-fit: contain !important;
    }
  }
}
</style>
